import React, { useRef } from "react";
import { AffiliatesHeroImgSection } from "../components/affiliates/content/layout/AffiliatesHeroImgSection";
import { Header } from "../components/_shared/Header";
import { Navbar } from "../components/_shared/Navbar";
import { BenefitProgramSection } from "../components/affiliates/content/layout/BenefitProgramSection";
import { HowToJoinSection } from "../components/affiliates/content/layout/HowToJoinSection";
import { JoinSentomReClubSection } from "../components/affiliates/content/layout/JoinSentomReClubSection";
import { FooterDemo } from "../components/_shared/FooterDemo";
import { FooterSocialMediaLine } from "../components/_shared/FooterSocialMediaLine";
import { AuthPopup } from "../components/_shared/AuthPopup";
import { AffiliatesJoinPopup } from "../components/affiliates/content/joinAffiliates/AffiliatesJoinPopup ";

export const Affiliates = () => {
  const howToJoinRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className="main-wrapper xxl-width">
      <>
        <div className="portfolio-header-sticky-wrapper">
          <div
            style={{
              backgroundColor: "rgba(255, 255, 255, 1)",
            }}
          >
            <Header>
              <Navbar />
            </Header>
          </div>
        </div>
        <AffiliatesHeroImgSection />
        <BenefitProgramSection howToJoinRef={howToJoinRef} />
        <HowToJoinSection howToJoinRef={howToJoinRef} />
        <JoinSentomReClubSection />
        <FooterDemo />
        <FooterSocialMediaLine />
        <AuthPopup />
        <AffiliatesJoinPopup />
      </>
    </div>
  );
};
